(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-savee-carousel]').forEach((rail) => {
    let paused = false;

    const advance = () => {
      if (paused || reducedMotion.matches || rail.scrollWidth <= rail.clientWidth) return;

      const card = rail.querySelector('.savee-home__product-card');
      const gap = parseFloat(window.getComputedStyle(rail).columnGap || '0');
      const amount = (card?.getBoundingClientRect().width || 280) + gap;
      const isAtEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;

      rail.scrollTo({
        left: isAtEnd ? 0 : rail.scrollLeft + amount,
        behavior: 'smooth',
      });
    };

    window.setInterval(advance, 4600);
    rail.addEventListener('mouseenter', () => { paused = true; });
    rail.addEventListener('mouseleave', () => { paused = false; });
    rail.addEventListener('focusin', () => { paused = true; });
    rail.addEventListener('focusout', () => { paused = false; });
  });

  const videos = [...document.querySelectorAll('.savee-home video')];

  const prepareVideo = (video) => {
    video.muted = true;
    video.playsInline = true;
  };

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && !reducedMotion.matches) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '160px 0px', threshold: 0.08 });

    videos.forEach((video) => {
      prepareVideo(video);
      videoObserver.observe(video);
    });
  } else {
    videos.forEach((video) => {
      prepareVideo(video);
      video.play().catch(() => {});
    });
  }
})();
